import React, { useState, useEffect } from 'react';
import { Search, Download, Calendar, Stethoscope, UserX, CheckCircle, XCircle } from 'lucide-react';
import * as XLSX from 'xlsx';

const ProcessoSeletivoExameAdmissao = () => {
    const [candidatos, setCandidatos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [filterNome, setFilterNome] = useState('');

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [candSelecionado, setCandSelecionado] = useState(null);
    const [anamneseTemporaria, setAnamneseTemp] = useState(''); 

    // Filtros
    const [filterCpf, setFilterCpf] = useState('');
    const [filterVaga, setFilterVaga] = useState('');

    // Gera a lista suspensa dinâmica das vagas
    const vagasDisponiveis = [...new Set(candidatos.map(c => c.CARGO).filter(Boolean))].sort();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch('/api/processo-seletivo/candidatos', { headers: { 'Authorization': `Bearer ${token}` }});
                if (!response.ok) throw new Error("Erro ao carregar dados.");
                setCandidatos(await response.json());
                setIsLoading(false);
            } catch (err) { setError(err.message); setIsLoading(false); }
        };
        fetchData();
    }, []);

    // Filtra primeiro os exames agendados (status 4 = exame de admissão)
    const examesAgendados = candidatos.filter(c =>
        c.DATA_HORA_EXAME !== null && c.STATUS_ETAPA === 4
    );

    // Aplica todos os filtros simultaneamente
    const candidatosFiltrados = examesAgendados.filter(cand => {
        const matchesNome = cand.NOME_COMPLETO?.toLowerCase().includes(filterNome.toLowerCase());
        const matchesCpf = cand.CPF?.replace(/\D/g, '').includes(filterCpf);
        const matchesVaga = filterVaga === '' || cand.CARGO === filterVaga;

        return matchesNome && matchesCpf && matchesVaga;
    });

    const abrirProntuario = (cand) => {
        setCandSelecionado(cand);
        setAnamneseTemp('');
        setIsModalOpen(true);
    };

    // --- NOVA LÓGICA SEM RELOAD ---
    const handleNaoCompareceu = async () => {
        if (!window.confirm(`Tem certeza que deseja registrar FALTA para ${candSelecionado.NOME_COMPLETO}? Ele será reprovado.`)) return;
        
        try {
            const token = localStorage.getItem('authToken');
            await fetch('/api/processo-seletivo/reprovar', {
                method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ idCandidato: candSelecionado.ID, motivo: "Não compareceu ao Exame Admissional", origem: 'Processo' })
            });
            setIsModalOpen(false);
            setCandidatos(prev => prev.filter(c => c.ID !== candSelecionado.ID)); // Remove instantaneamente
        } catch (error) { alert("Erro ao registrar falta."); }
    };

    // --- NOVA LÓGICA SEM RELOAD ---
    const handleInapto = async () => {
        if (!window.confirm(`ATENÇÃO: Deseja reprovar ${candSelecionado.NOME_COMPLETO} por inaptidão no exame médico?`)) return;
        
        try {
            const token = localStorage.getItem('authToken');
            await fetch('/api/processo-seletivo/reprovar', {
                method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ idCandidato: candSelecionado.ID, motivo: "Reprovado no Exame de Admissão (Inapto)", origem: 'Processo' })
            });
            setIsModalOpen(false);
            setCandidatos(prev => prev.filter(c => c.ID !== candSelecionado.ID)); // Remove instantaneamente
        } catch (error) { alert("Erro ao reprovar candidato."); }
    };

    // --- NOVA LÓGICA SEM RELOAD ---
    const handleFinalizarConsulta = async () => {
        if (!window.confirm("Confirmar que o candidato está APTO e finalizar a consulta?")) return;

        try {
            const token = localStorage.getItem('authToken');
            await fetch('/api/processo-seletivo/finalizar-exame', {
                method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ idCandidato: candSelecionado.ID, anamnese: anamneseTemporaria })
            });
            alert("Consulta finalizada! Candidato Apto para integração.");
            setIsModalOpen(false);
            setCandidatos(prev => prev.filter(c => c.ID !== candSelecionado.ID)); // Remove instantaneamente
        } catch (error) { alert("Erro ao finalizar a consulta."); }
    };

    const exportarExcel = () => {
        const dataToExport = candidatosFiltrados.map(cand => ({
            'Nome Completo': cand.NOME_COMPLETO,
            'Celular': cand.CELULAR,
            'Cargo': cand.CARGO,
            'Loja': cand.LOJA_ATUACAO,
            'Data do Exame': cand.DATA_HORA_EXAME ? new Date(cand.DATA_HORA_EXAME).toLocaleDateString('pt-BR') : '-',
            'Horário do Exame': cand.DATA_HORA_EXAME ? new Date(cand.DATA_HORA_EXAME).toLocaleTimeString('pt-BR', {hour: '2-digit', minute: '2-digit'}) : '-'
        }));
        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Agenda Clínica");
        XLSX.writeFile(wb, `Agenda_Clinica_Admissao.xlsx`);
    };

    if (isLoading) return <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>Carregando agenda...</div>;

    return (
        <div style={{ animation: 'fadeIn 0.3s ease-in-out' }}>
            <div style={{ marginBottom: '24px' }}>
                <h2 style={{ fontSize: '24px', fontWeight: '900', color: '#0f172a', marginBottom: '8px', margin: 0 }}>Atendimento Clínico (Exames)</h2>
                <p style={{ color: '#64748b', fontSize: '15px', margin: 0 }}>Realize os atendimentos e registre a aptidão ou o não comparecimento dos candidatos.</p>
            </div>

            <div style={{ backgroundColor: '#fff', borderRadius: '12px', padding: '20px', border: '1px solid #e2e8f0', marginBottom: '32px', display: 'flex', gap: '16px', alignItems: 'flex-end', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                <div style={{ flex: '1 1 200px' }}>
                    <label style={{ display: 'block', fontSize: '12px', fontWeight: '800', color: '#475569', textTransform: 'uppercase', marginBottom: '8px' }}>Nome do Paciente/Candidato</label>
                    <div style={{ position: 'relative' }}>
                        <Search size={16} color="#94a3b8" style={{ position: 'absolute', left: '12px', top: '12px' }} />
                        <input type="text" placeholder="Buscar paciente na fila..." value={filterNome} onChange={(e) => setFilterNome(e.target.value)} style={{ width: '100%', padding: '10px 10px 10px 36px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none' }} />
                    </div>
                </div>
                <div style={{ flex: '1 1 200px' }}>
                    <label style={{ display: 'block', fontSize: '12px', fontWeight: '800', color: '#475569', textTransform: 'uppercase', marginBottom: '8px' }}>CPF</label>
                    <div style={{ position: 'relative' }}>
                        <Search size={16} color="#94a3b8" style={{ position: 'absolute', left: '12px', top: '12px' }} />
                        <input type="text" placeholder="Apenas números..." value={filterCpf} onChange={(e) => setFilterCpf(e.target.value.replace(/\D/g, ''))} style={{ width: '100%', padding: '10px 10px 10px 36px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none' }} />
                    </div>
                </div>
                <div style={{ flex: '1 1 200px' }}>
                    <label style={{ display: 'block', fontSize: '12px', fontWeight: '800', color: '#475569', textTransform: 'uppercase', marginBottom: '8px' }}>Vaga Selecionada</label>
                    <select 
                        value={filterVaga} 
                        onChange={(e) => setFilterVaga(e.target.value)} 
                        style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none', color: '#475569', cursor: 'pointer', backgroundColor: '#fff' }}
                    >
                        <option value="">Todas as Vagas</option>
                        {vagasDisponiveis.map(vaga => <option key={vaga} value={vaga}>{vaga}</option>)}
                    </select>
                </div>
                <button onClick={exportarExcel} style={{ backgroundColor: '#10b981', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '8px', fontWeight: '800', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', height: '40px' }}><Download size={18} /> Exportar Fila</button>
            </div>

            <div style={{ backgroundColor: '#fff', borderRadius: '16px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#f8fafc', borderBottom: '2px solid #e11d48' }}>
                                <th style={{ padding: '16px 20px', color: '#475569', fontSize: '13px', fontWeight: '800', whiteSpace: 'nowrap' }}>Paciente (Candidato)</th>
                                <th style={{ padding: '16px 20px', color: '#475569', fontSize: '13px', fontWeight: '800', whiteSpace: 'nowrap' }}>Cargo Contratado</th>
                                <th style={{ padding: '16px 20px', color: '#475569', fontSize: '13px', fontWeight: '800', whiteSpace: 'nowrap', textAlign: 'center' }}>Data e Hora Marcada</th>
                                <th style={{ padding: '16px 20px', color: '#475569', fontSize: '13px', fontWeight: '800', whiteSpace: 'nowrap', textAlign: 'center' }}>Atendimento</th>
                            </tr>
                        </thead>
                        <tbody>
                            {candidatosFiltrados.length > 0 ? (
                                candidatosFiltrados.map((cand) => (
                                    <tr key={cand.ID} style={{ borderBottom: '1px solid #f1f5f9', transition: 'background-color 0.2s' }} onMouseOver={e => e.currentTarget.style.backgroundColor = '#f1f5f9'} onMouseOut={e => e.currentTarget.style.backgroundColor = 'transparent'}>
                                        <td style={{ padding: '16px 20px', whiteSpace: 'nowrap' }}>
                                            <strong style={{ color: '#0f172a', fontSize: '15px' }}>{cand.NOME_COMPLETO}</strong><br/>
                                            <span style={{ color: '#64748b', fontSize: '13px' }}>Cel: {cand.CELULAR}</span>
                                        </td>
                                        <td style={{ padding: '16px 20px', color: '#475569', fontSize: '14px', whiteSpace: 'nowrap' }}><strong style={{ color: '#0f172a' }}>{cand.CARGO}</strong><br/>{cand.LOJA_ATUACAO}</td>
                                        <td style={{ padding: '16px 20px', textAlign: 'center' }}>
                                            <span style={{ backgroundColor: '#eff6ff', color: '#1d4ed8', padding: '6px 14px', borderRadius: '9999px', fontSize: '13px', fontWeight: '800', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                                <Calendar size={16} />
                                                {cand.DATA_HORA_EXAME ? `${new Date(cand.DATA_HORA_EXAME).toLocaleDateString('pt-BR')} às ${new Date(cand.DATA_HORA_EXAME).toLocaleTimeString('pt-BR', {hour: '2-digit', minute: '2-digit'})}` : '-'}
                                            </span>
                                        </td>
                                        <td style={{ padding: '16px 20px', textAlign: 'center' }}>
                                            <button onClick={() => abrirProntuario(cand)} style={{ backgroundColor: '#e11d48', color: '#fff', border: 'none', padding: '8px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: '800', display: 'inline-flex', alignItems: 'center', gap: '8px', transition: 'all 0.2s', boxShadow: '0 2px 4px rgba(225, 29, 72, 0.2)' }}>
                                                <Stethoscope size={18} /> Atender
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : <tr><td colSpan={4} style={{ padding: '40px', textAlign: 'center', color: '#94a3b8' }}>Nenhum paciente aguardando na fila.</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* ====== MODAL: PRONTUÁRIO MÉDICO ====== */}
            {isModalOpen && candSelecionado && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(15, 23, 42, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999, animation: 'fadeIn 0.2s' }}>
                    <div style={{ backgroundColor: '#fff', borderRadius: '16px', width: '100%', maxWidth: '650px', overflow: 'hidden', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }}>
                        <div style={{ backgroundColor: '#e11d48', padding: '24px', color: '#fff' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                                <Stethoscope size={28} />
                                <h3 style={{ margin: 0, fontSize: '22px', fontWeight: '900' }}>Prontuário de Admissão</h3>
                            </div>
                            <p style={{ margin: 0, opacity: 0.9, fontSize: '15px' }}>Paciente: <strong>{candSelecionado.NOME_COMPLETO}</strong></p>
                        </div>
                        <div style={{ padding: '32px' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px', backgroundColor: '#f8fafc', padding: '16px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                                <div><span style={{ display: 'block', fontSize: '12px', color: '#64748b', fontWeight: '800', textTransform: 'uppercase' }}>Cargo Avaliado</span><strong style={{ color: '#0f172a' }}>{candSelecionado.CARGO}</strong></div>
                                <div><span style={{ display: 'block', fontSize: '12px', color: '#64748b', fontWeight: '800', textTransform: 'uppercase' }}>CPF</span><strong style={{ color: '#0f172a' }}>{candSelecionado.CPF.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")}</strong></div>
                            </div>
                            <div style={{ marginBottom: '32px' }}>
                                <label style={{ display: 'block', fontSize: '14px', fontWeight: '800', color: '#334155', marginBottom: '8px' }}>Descrição da Anamnese (Campos serão definidos em breve)</label>
                                <textarea value={anamneseTemporaria} onChange={(e) => setAnamneseTemp(e.target.value)} placeholder="Digite as observações médicas aqui..." style={{ width: '100%', minHeight: '120px', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none', resize: 'vertical', fontSize: '14px', fontFamily: 'inherit' }} />
                            </div>
                            <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', marginBottom: '24px' }}/>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <button onClick={() => setIsModalOpen(false)} style={{ background: 'transparent', border: 'none', color: '#64748b', fontWeight: '800', cursor: 'pointer', padding: '10px' }}>Cancelar</button>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <button onClick={handleNaoCompareceu} style={{ backgroundColor: '#fff', color: '#64748b', border: '1px solid #cbd5e1', padding: '12px 16px', borderRadius: '8px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', transition: 'all 0.2s' }} onMouseOver={e => { e.currentTarget.style.color = '#0f172a'; e.currentTarget.style.borderColor = '#94a3b8'; }} onMouseOut={e => { e.currentTarget.style.color = '#64748b'; e.currentTarget.style.borderColor = '#cbd5e1'; }}>
                                        <UserX size={16} /> Faltou
                                    </button>
                                    <button onClick={handleInapto} style={{ backgroundColor: '#fff', color: '#e11d48', border: '2px solid #e11d48', padding: '12px 16px', borderRadius: '8px', fontWeight: '800', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', transition: 'all 0.2s' }} onMouseOver={e => e.currentTarget.style.backgroundColor = '#fff1f2'} onMouseOut={e => e.currentTarget.style.backgroundColor = '#fff'}>
                                        <XCircle size={16} /> Inapto
                                    </button>
                                    <button onClick={handleFinalizarConsulta} style={{ backgroundColor: '#10b981', color: '#fff', border: 'none', padding: '12px 20px', borderRadius: '8px', fontWeight: '800', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', boxShadow: '0 4px 6px rgba(16, 185, 129, 0.2)' }}>
                                        <CheckCircle size={18} /> Finalizar (Apto)
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProcessoSeletivoExameAdmissao;